export default __webpack_public_path__ + "static/media/fresh-sidebar.b4009ecc.png";